import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import {
  ExpansionPanel,
  ExpansionPanelActionEvent,
  ExpansionPanelContent,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import {
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";
import ShadowCard from "../../components/common/ShadowCard";
import ButtonForAll from "../../components/common/Button";
import { getExportSalesOrderByPONO } from "../exportsalesorder/services/exporSalesOrder.services";
import { Reveal } from "@progress/kendo-react-animation";
import FormCheckbox from "../../components/formFields/FormCheckbox";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { Button } from "@progress/kendo-react-buttons";
import { ErrorToast } from "../../components/toast/Toasts";
import {
  createExportPacking,
  getAllPendingExportSO,
} from "./services/exportPacking.services";
import IconButton from "../../components/common/IconButton";
import { FaEdit } from "react-icons/fa";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  clearPoNo,
  setExportPackingItemID,
  setPoNo,
} from "./exportPackingSlice";
import UpdateExportPackingItem from "./UpdateExportPackingItem";
import { formatIndianNumberForQty } from "../../_helper/helper";
import { clearExportSalesOrderDetailByPONO } from "../exportsalesorder/exportSalesOrderSlice";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { IPendingSalesOrderList } from "./ExportPackingModel";
import { sumBy } from "lodash";

const CreateExportPacking: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const pono = location.state?.pono;

  const gridRef = useRef<any>(null);
  const expense_packing_guid = location.state?.expense_packing_guid;
  const loading = useAppSelector((state) => state.exportsalesorder.loading);
  const PackingLoading = useAppSelector((state) => state.exportpacking.loading);
  const ExportSalesOrderDetailByPONO = useAppSelector(
    (state) => state.exportsalesorder.ExportSalesOrderDetailByPONO
  );
  const PendingSalesOrderList = useAppSelector(
    (state) => state.exportpacking.PendingSalesOrderList
  );

  const [initialValues, setInitialValues] = useState({});
  const [formKey, setFormKey] = useState(1);
  const [RateData, setRateData] = useState<any[]>(
    JSON.parse(
      JSON.stringify(ExportSalesOrderDetailByPONO?.export_sales_order_pending)
    )
  );
  const [expanded, setExpanded] = React.useState<any>(0);
  const [expandedForPacking, setExpandedForPacking] = React.useState<any>(0);

  useEffect(() => {
    setRateData(ExportSalesOrderDetailByPONO?.export_sales_order_pending);
  }, [ExportSalesOrderDetailByPONO?.export_sales_order_pending]);

  useEffect(() => {
    dispatch(getAllPendingExportSO());
    return () => {
      dispatch(clearPoNo());
      dispatch(clearExportSalesOrderDetailByPONO());
      dispatch(closeDialog());
    };
  }, []);

  useEffect(() => {
    if (pono) {
      handlePONoChange(pono);
    }
  }, [pono]);

  // useEffect(() => {
  //   const newInitialValues =
  //     ExportSalesOrderDetailByPONO?.export_sales_order_pending &&
  //     ExportSalesOrderDetailByPONO?.export_sales_order_pending?.length > 0 &&
  //     ExportSalesOrderDetailByPONO?.export_sales_order_pending
  //       ?.map((item: any) => {
  //         return item?.export_sales_Order_itemwise?.map((subitem: any) => {
  //           return {
  //             pono: ExportSalesOrderDetailByPONO?.pono,
  //             [`packing_weight_${subitem?.item_id}`]: subitem?.packing_weight,
  //             [`total_kg_${subitem?.item_id}`]: subitem?.total_kg,
  //             [`quantity_ctn_${subitem?.item_id}`]: subitem?.quantity_ctn,
  //             [`barcode_${subitem?.item_id}`]: subitem?.barcode,
  //           };
  //         });
  //       })
  //       ?.reduce((acc: any, curr: any) => {
  //         return {
  //           ...ExportSalesOrderDetailByPONO?.export_sales_order_pending,
  //           ...acc,
  //           ...curr.reduce((subAcc: any, subCurr: any) => {
  //             return { ...subAcc, ...subCurr };
  //           }, {}),
  //         };
  //       }, {});

  //   if (JSON.stringify(newInitialValues) !== JSON.stringify(initialValues)) {
  //     setInitialValues(newInitialValues);
  //     setFormKey((prevKey) => prevKey + 1);
  //   }
  // }, [ExportSalesOrderDetailByPONO]);

  useEffect(() => {
    if (!ExportSalesOrderDetailByPONO) return;

    const ponoExists = ExportSalesOrderDetailByPONO?.pono ? true : false;

    const hasPendingData =
      ExportSalesOrderDetailByPONO?.export_sales_order_pending?.length > 0;

    let newInitialValues = initialValues;

    if (hasPendingData) {
      newInitialValues = ExportSalesOrderDetailByPONO.export_sales_order_pending
        .flatMap((item: any) =>
          item?.export_sales_Order_itemwise?.map((subitem: any) => ({
            pono: ExportSalesOrderDetailByPONO?.pono,
            [`packing_weight_${subitem?.item_id}`]: subitem?.packing_weight,
            [`total_kg_${subitem?.item_id}`]: subitem?.total_kg,
            [`quantity_ctn_${subitem?.item_id}`]: subitem?.quantity_ctn,
            [`barcode_${subitem?.item_id}`]: subitem?.barcode,
            [`size_c_${subitem?.item_id}`]: subitem?.size_c,
            [`size_b_${subitem?.item_id}`]: subitem?.size_b,
            [`size_m_${subitem?.item_id}`]: subitem?.size_m,
            [`total_${subitem?.item_id}`]: subitem?.total,
            [`sub_total_${subitem?.item_id}`]: subitem?.sub_total,
          }))
        )
        .reduce((acc: any, curr: any) => ({ ...acc, ...curr }), {});
    } else if (ponoExists) {
      newInitialValues = { pono: ExportSalesOrderDetailByPONO.pono };
    }

    if (JSON.stringify(newInitialValues) !== JSON.stringify(initialValues)) {
      setInitialValues(newInitialValues);
      setFormKey((prevKey) => prevKey + 1);
    }
  }, [ExportSalesOrderDetailByPONO]);

  const handleOpenEditDialog = (ID: string, PoNo: string) => {
    dispatch(openDialog("updateExportPackingItem"));
    dispatch(setExportPackingItemID(ID));
    dispatch(setPoNo(PoNo));
  };

  const handleQtyChange = (
    formRenderProps: FormRenderProps,
    mainIndex: number,
    subIndex: number,
    itemId: number
  ) => {
    const selected_row = formRenderProps.valueGetter(`selected_${itemId}`);
    const packing_weight = formRenderProps.valueGetter(
      `packing_weight_${itemId}`
    );
    const sr_no = formRenderProps.valueGetter(`sr_no_${itemId}`);
    const gross_kg = formRenderProps.valueGetter(`gross_kg_${itemId}`);
    // const net_kg = formRenderProps.valueGetter(`net_kg_${itemId}`);
    const quantity_ctn = formRenderProps.valueGetter(`quantity_ctn_${itemId}`);
    const size_c = formRenderProps.valueGetter(`size_c_${itemId}`);
    const size_b = formRenderProps.valueGetter(`size_b_${itemId}`);
    const size_m = formRenderProps.valueGetter(`size_m_${itemId}`);

    const conversion_unit_for_weight =
      RateData[mainIndex]?.export_sales_Order_itemwise[subIndex]
        ?.conversion_unit_for_weight;
    // const packing_size =
    //   RateData[mainIndex]?.export_sales_Order_itemwise[subIndex]?.packing_size;

    if (+packing_weight === 0) {
      formRenderProps.onChange(`packing_weight_${itemId}`, {
        value: null,
      });
    }

    formRenderProps.onChange(`total_kg_${itemId}`, {
      value:
        +conversion_unit_for_weight * +packing_weight * +quantity_ctn || null,
    });
    formRenderProps.onChange(`net_kg_${itemId}`, {
      value: +conversion_unit_for_weight * +packing_weight || null,
    });
    formRenderProps.onChange(`gross_weight_${itemId}`, {
      value: +gross_kg * +quantity_ctn || null,
    });
    formRenderProps.onChange(`net_weight_${itemId}`, {
      value:
        +conversion_unit_for_weight * +packing_weight * +quantity_ctn || null,
    });
    formRenderProps.onChange(`total_${itemId}`, {
      value:
        size_m && size_b && size_c
          ? (+size_c * +size_b * +size_m) / 1000000
          : "",
    });
    formRenderProps.onChange(`sub_total_${itemId}`, {
      value: ((+size_c * +size_b * +size_m) / 1000000) * quantity_ctn || null,
    });

    // RateData[mainIndex].export_sales_Order_itemwise[subIndex].selected =
    //   selected_row;
    // RateData[mainIndex].export_sales_Order_itemwise[subIndex].packing_weight =
    //   +packing_weight || 0;
    // RateData[mainIndex].export_sales_Order_itemwise[subIndex].total_kg =
    //   +packing_weight * +quantity_ctn || 0;
    // RateData[mainIndex].export_sales_Order_itemwise[subIndex].gross_kg =
    //   +gross_kg || 0;
    // RateData[mainIndex].export_sales_Order_itemwise[subIndex].net_kg =
    //   +net_kg || 0;
    // RateData[mainIndex].export_sales_Order_itemwise[subIndex].gross_weight =
    //   +gross_kg * +quantity_ctn || 0;
    // RateData[mainIndex].export_sales_Order_itemwise[subIndex].net_weight =
    //   +net_kg * +quantity_ctn || 0;
    const updatedRateData = [...RateData];
    updatedRateData[mainIndex] = {
      ...updatedRateData[mainIndex],
      export_sales_Order_itemwise: [
        ...updatedRateData[mainIndex].export_sales_Order_itemwise,
      ],
    };

    updatedRateData[mainIndex].export_sales_Order_itemwise[subIndex] = {
      ...updatedRateData[mainIndex].export_sales_Order_itemwise[subIndex],
      selected: selected_row,
      packing_weight: +packing_weight || 0,
      total_kg: +packing_weight * +quantity_ctn || 0,
      sr_no: sr_no || "",
      size_c: size_c || null,
      size_b: size_b || null,
      size_m: size_m || null,
      total:
        size_m && size_b && size_c
          ? (+size_c * +size_b * +size_m) / 1000000
          : null,
      sub_total:
        ((+size_c * +size_b * +size_m) / 1000000) * quantity_ctn || null,
      gross_kg: +gross_kg || 0,
      net_kg: +conversion_unit_for_weight * +packing_weight || 0,
      gross_weight: +gross_kg * +quantity_ctn || 0,
      net_weight:
        +conversion_unit_for_weight * +packing_weight * +quantity_ctn || 0,
    };

    setRateData(updatedRateData);
  };

  const handlePONoChange = (pono: any) => {
    dispatch(getExportSalesOrderByPONO(`${pono}`));
  };

  const handleSubmit = async (values: any) => {
    const updatedValue: any = RateData?.map((item: any) => ({
      ...item,
      export_sales_Order_itemwise: item?.export_sales_Order_itemwise?.filter(
        (subItem: any) => subItem.selected === true
      ),
    }))?.filter((item: any) => item?.export_sales_Order_itemwise?.length > 0);

    const place_order_items =
      updatedValue &&
      updatedValue.length > 0 &&
      updatedValue?.flatMap(
        (schemeitem: any) =>
          schemeitem?.export_sales_Order_itemwise &&
          schemeitem?.export_sales_Order_itemwise?.length > 0 &&
          schemeitem?.export_sales_Order_itemwise?.map((item: any) => {
            return {
              export_sales_order_item_id: item?.id ? +item?.id : null,
              item_id: item?.item_id ? +item?.item_id : null,
              packing_size: item?.packing_size ? +item?.packing_size : null,
              unit_id: item?.unit_id ? +item?.unit_id : null,
              packing_unit_id: item?.packing_unit_id
                ? +item?.packing_unit_id
                : null,
              packing_weight: values?.[`packing_weight_${item?.item_id}`]
                ? +values[`packing_weight_${item?.item_id}`]
                : null,
              total_weight: values?.[`total_kg_${item?.item_id}`]
                ? +values[`total_kg_${item?.item_id}`]
                : null,
              sr_no: values?.[`sr_no_${item?.item_id}`]
                ? values[`sr_no_${item?.item_id}`]
                : "",
              size_c: values?.[`size_c_${item?.item_id}`]
                ? +values[`size_c_${item?.item_id}`]
                : null,
              size_b: values?.[`size_b_${item?.item_id}`]
                ? +values[`size_b_${item?.item_id}`]
                : null,
              size_m: values?.[`size_m_${item?.item_id}`]
                ? +values[`size_m_${item?.item_id}`]
                : null,
              total: values?.[`total_${item?.item_id}`]
                ? +values[`total_${item?.item_id}`]
                : null,
              sub_total: values?.[`sub_total_${item?.item_id}`]
                ? +values[`sub_total_${item?.item_id}`]?.toFixed(3)
                : null,
              gross_kg: values?.[`gross_kg_${item?.item_id}`]
                ? +values[`gross_kg_${item?.item_id}`]
                : null,
              net_kg: values?.[`net_kg_${item?.item_id}`]
                ? +values[`net_kg_${item?.item_id}`]
                : null,
              gross_weight: values?.[`gross_weight_${item?.item_id}`]
                ? +values[`gross_weight_${item?.item_id}`]
                : null,
              net_weight: values?.[`net_weight_${item?.item_id}`]
                ? +values[`net_weight_${item?.item_id}`]
                : null,
              quantity_ctn: item?.quantity_ctn ? +item?.quantity_ctn : null,
            };
          })
      );

    if (!place_order_items) {
      ErrorToast("Please select atleast one item.");
    } else {
      try {
        const payload = [...place_order_items];
        const res = await dispatch(createExportPacking(payload));
        if (res.meta?.requestStatus === "fulfilled") {
          if (pono) {
            dispatch(getExportSalesOrderByPONO(`${values?.pono}`));
          } else {
            navigate("/exportpacking/edit", {
              state: {
                pono: values?.pono,
              },
            });
          }
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  return (
    <>
      {(loading || PackingLoading) && <LoadingPanel gridRef={gridRef} />}
      <UpdateExportPackingItem />
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={initialValues}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard style={{ padding: 12, marginBottom: 20 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 10, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <p className="fs-4" style={{ margin: 0, fontWeight: "bold" }}>
                    {expense_packing_guid
                      ? "Update Export Packing"
                      : "Add Export Packing"}
                  </p>
                </GridLayoutItem>
                {pono ? (
                  <GridLayoutItem>
                    <Field
                      name="pono"
                      label="Po. No."
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                      disabled={true}
                    />
                  </GridLayoutItem>
                ) : (
                  <>
                    <GridLayoutItem>
                      <Field
                        name="pono"
                        label="Po. No."
                        component={FormSelectionField}
                        validator={requiredValidator}
                        astrike={true}
                        options={PendingSalesOrderList?.map(
                          (so: IPendingSalesOrderList) => {
                            return {
                              value: `${so?.id}`,
                              label: `${so?.pono} - ${so?.party_name}`,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <ButtonForAll
                        label={"View"}
                        disabled={!formRenderProps.valueGetter("pono")}
                        style={{ marginTop: 35 }}
                        onClick={() =>
                          handlePONoChange(formRenderProps.valueGetter("pono"))
                        }
                      />
                    </GridLayoutItem>
                  </>
                )}
                <GridLayoutItem colSpan={3}>
                  <p className="fs-4" style={{ margin: 0, fontWeight: "bold" }}>
                    Pending Item List
                  </p>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  <div
                    className="container-fluid orderform"
                    style={{ padding: "0", minWidth: 800 }}
                  >
                    <div className="row">
                      <div className="col-12">
                        <div
                          style={{ overflow: "scroll", scrollbarWidth: "thin" }}
                        >
                          <table
                            cellSpacing={1}
                            cellPadding={2}
                            className="table table-bordered w-100  salesorder-print-table"
                            style={{ marginTop: 1, minWidth: 3000 }}
                          >
                            <tr
                              className="text-center fw-600 text-white bg-dark"
                              style={{ fontSize: 12 }}
                            >
                              <th
                                className="pb-3 pt-3"
                                style={{ width: "2%" }}
                                rowSpan={2}
                              ></th>
                              <th
                                className="pb-3 pt-3"
                                style={{ width: "3%" }}
                                rowSpan={2}
                              >
                                No.
                              </th>
                              <th style={{ width: "13%" }} rowSpan={2}>
                                Description Of Goods
                              </th>
                              <th style={{ width: "8%" }} rowSpan={2}>
                                Alias Name
                              </th>
                              <th
                                style={{ width: "12%" }}
                                rowSpan={2}
                                colSpan={2}
                              >
                                Packing
                              </th>
                              <th style={{ width: "6%" }} rowSpan={2}>
                                Cartoon
                              </th>
                              <th style={{ width: "6%" }} rowSpan={2}>
                                Total KG
                              </th>
                              <th style={{ width: "6%" }} rowSpan={2}>
                                Sr. No.
                              </th>
                              <th style={{ width: "4%" }} rowSpan={2}>
                                C
                              </th>
                              <th style={{ width: "4%" }} rowSpan={2}>
                                B
                              </th>
                              <th style={{ width: "4%" }} rowSpan={2}>
                                M
                              </th>
                              <th style={{ width: "6%" }} rowSpan={2}>
                                Total
                              </th>
                              <th style={{ width: "6%" }} rowSpan={2}>
                                Sub Total
                              </th>
                              <th style={{ width: "10%" }} colSpan={2}>
                                Weight
                              </th>
                              <th style={{ width: "10%" }} colSpan={2}>
                                Total Weight
                              </th>
                            </tr>
                            <tr
                              className="text-center fw-600 text-white bg-dark"
                              style={{ fontSize: 12 }}
                            >
                              <th style={{ width: "5%" }}>Gross KG</th>
                              <th style={{ width: "5%" }}>Net KG</th>
                              <th style={{ width: "5%" }}>Gross</th>
                              <th style={{ width: "5%" }}>Net</th>
                            </tr>
                            {RateData && RateData.length > 0 ? (
                              RateData?.map((item: any, mainIndex: number) => (
                                <tr key={mainIndex}>
                                  <td colSpan={18} className="p-0">
                                    <ExpansionPanel
                                      title={item?.item_group}
                                      expanded={expanded === mainIndex}
                                      tabIndex={0}
                                      key={item.id}
                                      onAction={(
                                        event: ExpansionPanelActionEvent
                                      ) => {
                                        const nativeEvent =
                                          event.nativeEvent as KeyboardEvent;
                                        if (
                                          nativeEvent.type === "keydown" &&
                                          nativeEvent.code === "Space"
                                        ) {
                                          nativeEvent.preventDefault();
                                          return;
                                        }

                                        setExpanded(
                                          event.expanded ? null : mainIndex
                                        );
                                      }}
                                    >
                                      <Reveal>
                                        {expanded === mainIndex && (
                                          <ExpansionPanelContent>
                                            {item?.export_sales_Order_itemwise &&
                                              item?.export_sales_Order_itemwise
                                                ?.length > 0 &&
                                              item?.export_sales_Order_itemwise?.map(
                                                (
                                                  subitem: any,
                                                  subIndex: number
                                                ) => (
                                                  <div
                                                    key={subIndex}
                                                    id={`collapse${mainIndex}`}
                                                  >
                                                    <div
                                                      style={{
                                                        padding: "5px 0",
                                                      }}
                                                    >
                                                      <table
                                                        style={{
                                                          width: "100%",
                                                        }}
                                                      >
                                                        <tr
                                                          style={{
                                                            verticalAlign:
                                                              "baseline",
                                                          }}
                                                        >
                                                          <td
                                                            style={{
                                                              width: "2%",
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="d-flex justify-content-center scheme-checkbox"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`selected_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              onChange={() =>
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  subitem?.item_id
                                                                )
                                                              }
                                                              component={
                                                                FormCheckbox
                                                              }
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "3%",
                                                            }}
                                                            className="text-center"
                                                          >
                                                            {subIndex + 1}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "13%",
                                                            }}
                                                          >
                                                            {subitem?.item_name}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "8%",
                                                            }}
                                                          >
                                                            {
                                                              subitem?.alias_name
                                                            }
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "5%",
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                display: "flex",
                                                                gap: 5,
                                                                alignItems:
                                                                  "center",
                                                              }}
                                                            >
                                                              <span
                                                                style={{
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                }}
                                                              >
                                                                {`${subitem?.packing_size} ${subitem?.unit_code}`}
                                                              </span>
                                                              <span>X</span>
                                                            </div>
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "7%",
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                display: "flex",
                                                                gap: 5,
                                                                alignItems:
                                                                  "center",
                                                              }}
                                                            >
                                                              <Field
                                                                wrapperClassName="right-alighned-field flex-1"
                                                                wrapperStyle={{
                                                                  margin: 0,
                                                                }}
                                                                name={`packing_weight_${subitem?.item_id}`}
                                                                placeholder="0"
                                                                onChange={() =>
                                                                  handleQtyChange(
                                                                    formRenderProps,
                                                                    mainIndex,
                                                                    subIndex,
                                                                    subitem?.item_id
                                                                  )
                                                                }
                                                                validator={
                                                                  formRenderProps.valueGetter(
                                                                    `selected_${subitem?.item_id}`
                                                                  )
                                                                    ? requiredValidator
                                                                    : skipValidator
                                                                }
                                                                disabled={
                                                                  !formRenderProps.valueGetter(
                                                                    `selected_${subitem?.item_id}`
                                                                  )
                                                                }
                                                                format="n2"
                                                                component={
                                                                  FormNumericTextField
                                                                }
                                                              />
                                                              <span>
                                                                {
                                                                  subitem?.packing_unit
                                                                }
                                                              </span>
                                                            </div>
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "6%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="right-alighned-field"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`quantity_ctn_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              onChange={() =>
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  subitem?.item_id
                                                                )
                                                              }
                                                              validator={
                                                                formRenderProps.valueGetter(
                                                                  `selected_${subitem?.item_id}`
                                                                )
                                                                  ? requiredValidator
                                                                  : skipValidator
                                                              }
                                                              disabled={
                                                                !formRenderProps.valueGetter(
                                                                  `selected_${subitem?.item_id}`
                                                                )
                                                              }
                                                              format="n0"
                                                              component={
                                                                FormNumericTextField
                                                              }
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "6%",
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="right-alighned-field"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`total_kg_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              disabled={true}
                                                              format="n2"
                                                              component={
                                                                FormNumericTextField
                                                              }
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "6%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`sr_no_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              onKeyDown={(
                                                                e: any
                                                              ) => {
                                                                if (
                                                                  e.key ===
                                                                    " " ||
                                                                  e.key ===
                                                                    "Tab"
                                                                ) {
                                                                  formRenderProps.onChange(
                                                                    `sr_no_${subitem?.item_id}`,
                                                                    {
                                                                      value: `${e?.target?.value} `,
                                                                    }
                                                                  );
                                                                }
                                                              }}
                                                              onChange={() => {
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  subitem?.item_id
                                                                );
                                                              }}
                                                              disabled={
                                                                !formRenderProps.valueGetter(
                                                                  `selected_${subitem?.item_id}`
                                                                )
                                                              }
                                                              component={
                                                                FormTextField
                                                              }
                                                              type="text"
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "4%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="right-alighned-field"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`size_c_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              onChange={() => {
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  subitem?.item_id
                                                                );
                                                              }}
                                                              disabled={
                                                                !formRenderProps.valueGetter(
                                                                  `selected_${subitem?.item_id}`
                                                                )
                                                              }
                                                              component={
                                                                FormNumericTextField
                                                              }
                                                              type="text"
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "4%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="right-alighned-field"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`size_b_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              onChange={() => {
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  subitem?.item_id
                                                                );
                                                              }}
                                                              disabled={
                                                                !formRenderProps.valueGetter(
                                                                  `selected_${subitem?.item_id}`
                                                                )
                                                              }
                                                              component={
                                                                FormNumericTextField
                                                              }
                                                              type="text"
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "4%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="right-alighned-field"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`size_m_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              onChange={() => {
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  subitem?.item_id
                                                                );
                                                              }}
                                                              disabled={
                                                                !formRenderProps.valueGetter(
                                                                  `selected_${subitem?.item_id}`
                                                                )
                                                              }
                                                              component={
                                                                FormNumericTextField
                                                              }
                                                              type="text"
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "6%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="right-alighned-field"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`total_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              onChange={() =>
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  subitem?.item_id
                                                                )
                                                              }
                                                              disabled={true}
                                                              component={
                                                                FormTextField
                                                              }
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "6%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="right-alighned-field"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`sub_total_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              onChange={() =>
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  subitem?.item_id
                                                                )
                                                              }
                                                              disabled={true}
                                                              format="n3"
                                                              component={
                                                                FormNumericTextField
                                                              }
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "5%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="right-alighned-field"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`gross_kg_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              onChange={() =>
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  subitem?.item_id
                                                                )
                                                              }
                                                              disabled={
                                                                !formRenderProps.valueGetter(
                                                                  `selected_${subitem?.item_id}`
                                                                )
                                                              }
                                                              format="n3"
                                                              component={
                                                                FormNumericTextField
                                                              }
                                                              validator={
                                                                formRenderProps.valueGetter(
                                                                  `selected_${subitem?.item_id}`
                                                                )
                                                                  ? requiredValidator
                                                                  : skipValidator
                                                              }
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "5%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="right-alighned-field"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`net_kg_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              onChange={() =>
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  subitem?.item_id
                                                                )
                                                              }
                                                              disabled={true}
                                                              format="n3"
                                                              component={
                                                                FormNumericTextField
                                                              }
                                                              validator={
                                                                formRenderProps.valueGetter(
                                                                  `selected_${subitem?.item_id}`
                                                                )
                                                                  ? requiredValidator
                                                                  : skipValidator
                                                              }
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "5%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="right-alighned-field"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`gross_weight_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              onChange={() =>
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  subitem?.item_id
                                                                )
                                                              }
                                                              disabled={true}
                                                              format="n3"
                                                              component={
                                                                FormNumericTextField
                                                              }
                                                              validator={
                                                                formRenderProps.valueGetter(
                                                                  `selected_${subitem?.item_id}`
                                                                )
                                                                  ? requiredValidator
                                                                  : skipValidator
                                                              }
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "5%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            <Field
                                                              wrapperClassName="right-alighned-field"
                                                              wrapperStyle={{
                                                                margin: 0,
                                                              }}
                                                              name={`net_weight_${subitem?.item_id}`}
                                                              placeholder="0"
                                                              disabled={true}
                                                              onChange={() =>
                                                                handleQtyChange(
                                                                  formRenderProps,
                                                                  mainIndex,
                                                                  subIndex,
                                                                  subitem?.item_id
                                                                )
                                                              }
                                                              format="n3"
                                                              component={
                                                                FormNumericTextField
                                                              }
                                                              validator={
                                                                formRenderProps.valueGetter(
                                                                  `selected_${subitem?.item_id}`
                                                                )
                                                                  ? requiredValidator
                                                                  : skipValidator
                                                              }
                                                            />
                                                          </td>
                                                        </tr>
                                                      </table>
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                          </ExpansionPanelContent>
                                        )}
                                      </Reveal>
                                    </ExpansionPanel>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={13} className="text-center p-2">
                                  No Records Found
                                </td>
                              </tr>
                            )}
                          </table>
                        </div>
                      </div>
                      <div
                        className="col-12"
                        style={{
                          textAlign: "end",
                          marginTop: "20px",
                          width: "100%",
                        }}
                      >
                        <ButtonWithLoading
                          label={expense_packing_guid ? "Update" : "Save"}
                          type="submit"
                          disabled={!formRenderProps.allowSubmit || loading}
                          loading={loading}
                        />
                        <Button
                          type="button"
                          fillMode={"outline"}
                          themeColor={"primary"}
                          style={{ marginLeft: 4 }}
                          onClick={() => navigate("/exportpacking")}
                        >
                          Cancel
                        </Button>
                      </div>
                    </div>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
      {ExportSalesOrderDetailByPONO?.export_sales_order_packing_list &&
        ExportSalesOrderDetailByPONO?.export_sales_order_packing_list?.length >
          0 && (
          <ShadowCard style={{ padding: 12, marginBottom: 20 }}>
            <GridLayout
              style={{ marginRight: 20 }}
              gap={{ rows: 10, cols: 10 }}
              cols={[
                { width: "33.33%" },
                { width: "33.33%" },
                { width: "33.33%" },
              ]}
            >
              <GridLayoutItem colSpan={3}>
                <p className="fs-4" style={{ margin: 0, fontWeight: "bold" }}>
                  Export Packing List
                </p>
              </GridLayoutItem>
              <GridLayoutItem colSpan={3}>
                <div
                  className="container-fluid orderform packinglist"
                  style={{ padding: "0", minWidth: 800 }}
                >
                  <div className="row">
                    <div className="col-12">
                      <div
                        style={{ overflow: "scroll", scrollbarWidth: "thin" }}
                      >
                        <table
                          cellSpacing={1}
                          cellPadding={2}
                          className="table table-bordered w-100  salesorder-print-table"
                          style={{ marginTop: 1, minWidth: 3000 }}
                        >
                          <tr
                            className="text-center fw-600 text-white bg-dark"
                            style={{ fontSize: 12 }}
                          >
                            <th style={{ width: "12%" }} rowSpan={2}>
                              Description Of Goods
                            </th>
                            <th style={{ width: "8%" }} rowSpan={2}>
                              Alias Name
                            </th>
                            <th style={{ width: "5%" }} rowSpan={2}>
                              Packing Size
                            </th>
                            <th style={{ width: "7%" }} rowSpan={2}>
                              Packing Weight
                            </th>
                            <th style={{ width: "4%" }} rowSpan={2}>
                              Cartoon
                            </th>
                            <th style={{ width: "6%" }} rowSpan={2}>
                              Total KG
                            </th>
                            <th style={{ width: "8%" }} rowSpan={2}>
                              Sr. No.
                            </th>
                            <th style={{ width: "4%" }} rowSpan={2}>
                              C
                            </th>
                            <th style={{ width: "4%" }} rowSpan={2}>
                              B
                            </th>
                            <th style={{ width: "4%" }} rowSpan={2}>
                              M
                            </th>
                            <th style={{ width: "6%" }} rowSpan={2}>
                              Total
                            </th>
                            <th style={{ width: "6%" }} rowSpan={2}>
                              Sub Total
                            </th>
                            <th style={{ width: "10%" }} colSpan={2}>
                              Weight
                            </th>
                            <th style={{ width: "10%" }} colSpan={2}>
                              Total Weight
                            </th>
                            <th
                              className="pb-3 pt-3"
                              style={{ width: "6%", minWidth: 80 }}
                              rowSpan={2}
                            >
                              Action
                            </th>
                          </tr>
                          <tr
                            className="text-center fw-600 text-white bg-dark"
                            style={{ fontSize: 11 }}
                          >
                            <th style={{ width: "5%" }}>Gross KG</th>
                            <th style={{ width: "5%" }}>Net KG</th>
                            <th style={{ width: "5%" }}>Gross</th>
                            <th style={{ width: "5%" }}>Net</th>
                          </tr>
                          {ExportSalesOrderDetailByPONO?.export_sales_order_packing_list &&
                          ExportSalesOrderDetailByPONO
                            ?.export_sales_order_packing_list?.length > 0 ? (
                            ExportSalesOrderDetailByPONO?.export_sales_order_packing_list?.map(
                              (item: any, mainIndex: number) => (
                                <tr key={mainIndex}>
                                  <td colSpan={17} className="p-0">
                                    <ExpansionPanel
                                      title={item?.item_group}
                                      expanded={
                                        expandedForPacking === mainIndex
                                      }
                                      tabIndex={0}
                                      key={item.id}
                                      onAction={(
                                        event: ExpansionPanelActionEvent
                                      ) => {
                                        const nativeEvent =
                                          event.nativeEvent as KeyboardEvent;
                                        if (
                                          nativeEvent.type === "keydown" &&
                                          nativeEvent.code === "Space"
                                        ) {
                                          nativeEvent.preventDefault();
                                          return;
                                        }

                                        setExpandedForPacking(
                                          event.expanded ? null : mainIndex
                                        );
                                      }}
                                    >
                                      <Reveal>
                                        {expandedForPacking === mainIndex && (
                                          <ExpansionPanelContent>
                                            {item?.export_sales_Order_itemwise &&
                                              item?.export_sales_Order_itemwise
                                                ?.length > 0 &&
                                              item?.export_sales_Order_itemwise?.map(
                                                (
                                                  subitem: any,
                                                  subIndex: number
                                                ) => (
                                                  <div
                                                    key={subIndex}
                                                    id={`collapse${mainIndex}`}
                                                  >
                                                    <div>
                                                      <table
                                                        style={{
                                                          width: "100%",
                                                        }}
                                                      >
                                                        <tr
                                                          style={{
                                                            verticalAlign:
                                                              "baseline",
                                                          }}
                                                        >
                                                          <td
                                                            style={{
                                                              width: "12%",
                                                            }}
                                                          >
                                                            {subitem?.item_name}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "8%",
                                                            }}
                                                          >
                                                            {
                                                              subitem?.alias_name
                                                            }
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "5%",
                                                              minWidth: 100,
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                whiteSpace:
                                                                  "nowrap",
                                                              }}
                                                            >
                                                              {`${subitem?.packing_size} ${subitem?.unit_code}`}
                                                            </div>
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "7%",
                                                              minWidth: 100,
                                                            }}
                                                          >
                                                            {`${subitem?.packing_weight} ${subitem?.packing_unit}`}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "4%",
                                                              minWidth: 100,
                                                              textAlign: "end",
                                                            }}
                                                          >
                                                            {
                                                              subitem?.quantity_ctn
                                                            }
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "6%",
                                                              minWidth: 100,
                                                              textAlign: "end",
                                                            }}
                                                          >
                                                            {subitem?.total_weight
                                                              ? formatIndianNumberForQty(
                                                                  subitem?.total_weight
                                                                )
                                                              : ""}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "8%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            {subitem?.sr_no}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "4%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            {subitem?.size_c}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "4%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            {subitem?.size_b}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "4%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            {subitem?.size_m}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "6%",
                                                              textAlign: "end",
                                                            }}
                                                          >
                                                            {subitem?.total}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "6%",
                                                              textAlign: "end",
                                                            }}
                                                          >
                                                            {subitem?.sub_total}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "5%",
                                                              textAlign: "end",
                                                            }}
                                                          >
                                                            {subitem?.gross_kg
                                                              ? formatIndianNumberForQty(
                                                                  subitem?.gross_kg
                                                                )
                                                              : ""}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "5%",
                                                              textAlign: "end",
                                                            }}
                                                          >
                                                            {subitem?.net_kg
                                                              ? formatIndianNumberForQty(
                                                                  subitem?.net_kg
                                                                )
                                                              : ""}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "5%",
                                                              textAlign: "end",
                                                            }}
                                                          >
                                                            {subitem?.gross_weight
                                                              ? formatIndianNumberForQty(
                                                                  subitem?.gross_weight
                                                                )
                                                              : ""}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "5%",
                                                              textAlign: "end",
                                                            }}
                                                          >
                                                            {subitem?.net_weight
                                                              ? formatIndianNumberForQty(
                                                                  subitem?.net_weight
                                                                )
                                                              : ""}
                                                          </td>
                                                          <td
                                                            style={{
                                                              width: "6%",
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            <IconButton
                                                              type="button"
                                                              fillMode="flat"
                                                              size="small"
                                                              title="Delete"
                                                              onClick={() =>
                                                                handleOpenEditDialog(
                                                                  subitem?.export_packing_guid,
                                                                  ExportSalesOrderDetailByPONO?.pono
                                                                )
                                                              }
                                                            >
                                                              <FaEdit
                                                                className="absolute-position"
                                                                style={{
                                                                  fontSize:
                                                                    "24px",
                                                                }}
                                                              />
                                                            </IconButton>
                                                          </td>
                                                        </tr>
                                                      </table>
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                          </ExpansionPanelContent>
                                        )}
                                      </Reveal>
                                    </ExpansionPanel>
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan={12} className="text-center p-2">
                                No Records Found
                              </td>
                            </tr>
                          )}
                          {ExportSalesOrderDetailByPONO?.export_sales_order_packing_list &&
                            ExportSalesOrderDetailByPONO
                              ?.export_sales_order_packing_list.length > 0 && (
                              <tr
                                style={{
                                  background: "whitesmoke",
                                  fontWeight: "bold",
                                }}
                              >
                                <td
                                  colSpan={4}
                                  style={{
                                    textAlign: "end",
                                    padding: 5,
                                  }}
                                >
                                  Total
                                </td>
                                <td
                                  style={{
                                    textAlign: "end",
                                    borderRight: "1px solid white",
                                    borderLeft: "1px solid white",
                                  }}
                                >
                                  {sumBy(
                                    ExportSalesOrderDetailByPONO.export_sales_order_packing_list.flatMap(
                                      (group) =>
                                        group.export_sales_Order_itemwise
                                    ),
                                    "quantity_ctn"
                                  )}
                                </td>
                                <td
                                  style={{
                                    textAlign: "end",
                                    borderRight: "1px solid white",
                                  }}
                                >
                                  {sumBy(
                                    ExportSalesOrderDetailByPONO.export_sales_order_packing_list.flatMap(
                                      (group) =>
                                        group.export_sales_Order_itemwise
                                    ),
                                    "total_weight"
                                  )?.toFixed(3)}
                                </td>
                                <td
                                  style={{
                                    padding: 5,
                                  }}
                                ></td>
                                <td
                                  style={{
                                    padding: 5,
                                  }}
                                ></td>
                                <td
                                  style={{
                                    padding: 5,
                                  }}
                                ></td>
                                <td
                                  style={{
                                    padding: 5,
                                  }}
                                ></td>
                                <td
                                  style={{
                                    padding: 5,
                                  }}
                                ></td>
                                <td
                                  style={{
                                    textAlign: "end",

                                    borderLeft: "1px solid white",
                                  }}
                                >
                                  {sumBy(
                                    ExportSalesOrderDetailByPONO.export_sales_order_packing_list.flatMap(
                                      (group) =>
                                        group.export_sales_Order_itemwise
                                    ),
                                    "sub_total"
                                  )?.toFixed(3)}
                                </td>
                                <td
                                  style={{
                                    textAlign: "end",
                                    borderLeft: "1px solid white",
                                  }}
                                >
                                  {sumBy(
                                    ExportSalesOrderDetailByPONO.export_sales_order_packing_list.flatMap(
                                      (group) =>
                                        group.export_sales_Order_itemwise
                                    ),
                                    "gross_kg"
                                  )?.toFixed(3)}
                                </td>
                                <td
                                  style={{
                                    textAlign: "end",
                                    borderRight: "1px solid white",
                                    borderLeft: "1px solid white",
                                  }}
                                >
                                  {sumBy(
                                    ExportSalesOrderDetailByPONO.export_sales_order_packing_list.flatMap(
                                      (group) =>
                                        group.export_sales_Order_itemwise
                                    ),
                                    "net_kg"
                                  )?.toFixed(3)}
                                </td>
                                <td
                                  style={{
                                    textAlign: "end",
                                    borderRight: "1px solid white",
                                  }}
                                >
                                  {sumBy(
                                    ExportSalesOrderDetailByPONO.export_sales_order_packing_list.flatMap(
                                      (group) =>
                                        group.export_sales_Order_itemwise
                                    ),
                                    "gross_weight"
                                  )?.toFixed(3)}
                                </td>
                                <td
                                  style={{
                                    textAlign: "end",
                                    borderRight: "1px solid white",
                                    borderLeft: "1px solid white",
                                  }}
                                >
                                  {sumBy(
                                    ExportSalesOrderDetailByPONO.export_sales_order_packing_list.flatMap(
                                      (group) =>
                                        group.export_sales_Order_itemwise
                                    ),
                                    "net_weight"
                                  )?.toFixed(3)}
                                </td>
                                <td></td>
                              </tr>
                            )}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </GridLayoutItem>
            </GridLayout>
          </ShadowCard>
        )}
    </>
  );
};

export default CreateExportPacking;
